module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAU5JREFUeF7tmlEOwjAMQ7ObwcmAkwEng+UPoVJFwtES9fVvaMpcNzGplc0WX9vi+zcIIAMWZ4ASWDwBQiJ4MrNLU6JuZvaYYY+UgBNwb0rAGQLIAEoADcgSQVfYq1gcX4N4foIuZrPlOEb/VKkiCAGrZ4A4+1PCpZZACmJxUAigE6QT1HSCS98GxbpUK1zkOlwLsRhNhAD3AzovLkNZl6EOWUEjRCNEI6RphEausPsB6jVquFzFn4EPYYgMSEoVQRyh3YdzD++zmfp+9kMZ/fYro1uVQKAsD38ltQQO310AAATQCNEIaRqhQLmVfeXv63DZnSmARQwRxXfKxogQwIgMIzLMCDEkxZRYWRmfA0u9C+AH7OQzIyQujVZDUuK9p4RL1YAUxOKgEIAhgiGiMUQYkRGLU5lwET+gDNgMIBCQwWqnmGRAp9PKwLp8BrwBovSDQXD7T7UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index (6).png
// module id = B4dD
// module chunks = 9